/** Brunei national design tokens — SERPS ui-kit */

export const colors = {
  primary: {
    yellow: '#F7D000',      // Royal Yellow — only use on .dark/charcoal
    yellowDark: '#D4A800',  // hover/active on dark surfaces
    yellowLight: '#FFF8D6', // subtle highlight on light surfaces
  },
  neutral: {
    black: '#1A1A1A',
    charcoal: '#2D2D2D',
    gray800: '#424242',
    gray600: '#757575',
    gray400: '#BDBDBD',
    gray200: '#EEEEEE',
    gray100: '#F5F5F5',
    white: '#FFFFFF',
  },
  semantic: {
    success: '#2E7D32',
    successDark: '#1B5E20',
    successBg: '#E8F5E9',
    error: '#C62828',
    errorDark: '#B71C1C',
    errorBg: '#FFEBEE',
    warning: '#F57F17',
    warningDark: '#7A5A00',
    warningBg: '#FFF8E1',
    info: '#1565C0',
    infoDark: '#0D47A1',
    infoBg: '#E3F2FD',
  },
} as const;

export const typography = {
  fontFamily: {
    heading: '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    mono: '"Courier New", monospace',
  },
  fontSize: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
    '4xl': '36px',
  },
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeight: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75,
  },
} as const;

export const spacing = {
  '0': '0px',
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  '2xl': '48px',
  '3xl': '64px',
} as const;

export const borderRadius = {
  none: '0px',
  xs: '2px',
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  full: '9999px',
} as const;

export const shadows = {
  none: 'none',
  sm: '0 1px 2px rgba(0,0,0,0.05)',
  md: '0 4px 6px rgba(0,0,0,0.1)',
  lg: '0 10px 15px rgba(0,0,0,0.15)',
  xl: '0 20px 25px rgba(0,0,0,0.2)',
  focus: `0 0 0 3px rgba(247,208,0,0.4)`,
  focusDark: `0 0 0 3px rgba(247,208,0,0.5)`,
} as const;

export const breakpoints = {
  xs: '0px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
} as const;

export const transition = {
  fast: 'all 0.15s ease-in-out',
  base: 'all 0.2s ease-in-out',
  slow: 'all 0.3s ease-in-out',
} as const;

/** Legacy export — kept for backwards-compat */
const designTokens = { colors, typography, spacing, borderRadius, shadows, breakpoints, transition };
export default designTokens;
